<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.invoice')}}</div>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="invoice.invoice_number"
                            :label="__('labels.invoice_invoice_number')"
                            :hint="__('labels.invoice_invoice_number_hint')"
                            :rules="rules.invoice_number">
                    </s-text-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-date-picker
                            v-model="invoice.invoice_date"
                            :label="__('labels.invoice_invoice_date')"
                            :rules="rules.date"
                            :max="max"
                    ></s-date-picker>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-text-field
                            v-model="invoice.tax_id"
                            name="tax_id"
                            :label="__('labels.invoice_tax_id')"
                            :rules="rules.tax_id"

                    ></s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "InvoiceStep",
        computed: {
            ...mapState('form', [
                'invoice',
                'performanceDates',
                'address',
            ]),
            max() {
                return this.$moment().format('YYYY-MM-DD');
            },
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({
                        invoice_number: ['required', 'match:[A-Za-z0-9\-_]*:'+this.__('errors.invalid_invoice_number')],
                        date: ['required'],
                        tax_id: [v => this.address.country_code !== 'DE' || !!v || this.__('errors.required')],
                    }
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$cookies.set('invoice', this.invoice);
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>